import { getDashboardDataPoints } from '../Restclient/datacollection';
import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import PropTypes, { object } from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useSelector, useDispatch } from "react-redux";
import "../cssfiles/homepage.css";
import RightPane from "./RightPane";
import { Stack, Grid } from "@mui/material";
import { Responsive, WidthProvider } from "react-grid-layout";
import Divider from '@mui/material/Divider';
import Breadcrumbs from "@mui/material/Breadcrumbs";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Overviewjson from "./Dashboards/TempJson/Overviewdashboard";
import Energyanalyticsjson from "./Dashboards/TempJson/Energyanalytics";
import Energyaccountingjson from "./Dashboards/TempJson/Energyaccounting";
import Powerqualityjson from "./Dashboards/TempJson/Powerquality";
import Sustainabilityjson from "./Dashboards/TempJson/Sustainability";
import Widgetcard from "./Dashboards/Widgetcard";
import WidgetCard from './ConfigPages/DashboardConfigurator/Dashboard/Widget/utils/WidgetCard';

import Environmentjson from "./Dashboards/TempJson/Environment";
import Skeleton from '@mui/material/Skeleton';
import Socialjson from "./Dashboards/TempJson/Social";
import Governancejson from "./Dashboards/TempJson/Governance";
import {
  updatetabpath,
  updatedashboarddata,
  updatetagcollectionvalue,
  updatelivedata,
  updatehistoricalvalue,
  updatedashboardjsontags,
  updatetagcollectionvaluenewjson,
  updatetagaliascollectionvaluenewjson,
  updategeneralconfig
} from "../store/mainpage_data";
import AssetMaintenancejson from "./Dashboards/TempJson/AssetMaintenance";
import {
  getdashboarddetails,
  getGeneralConfiguration
} from "../Restclient/datacollection";
import {
  getdashboarddata,
  getdashboardhistoricaldata,
  gethistoricaldata,
} from "../Restclient/datacollection";
//import SLDimage from "../images/SLD.png";
import SLDimage_Baroda from "../images/SLD_Baroda.png";
import SLDimage_Delhi from "../images/SLD_Delhi.png";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {
  tag_collection_query_db,
  flag,
  tagcollection,
  tagcollectionreplica,
  datacollect,
} from "./DataCollection";
import { livedata } from "../Restclient/datacollection";
import ThermalManagement from "./DigitalTwin/ThermalManagement";
import ThreeDScene from "./DigitalTwin/ThreeDScene";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
//import ChatWidget from './Widgets/ChatBot/ChatWidget';
import LK_Loading from "../images/LK_Loading.gif";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

export default function Dashboard() {
  var timervariable = 0;
  const dispatch = useDispatch();
  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate
  );
  const generalconfig = useSelector((state) => state.mainpagedata.generalconfig);
  const selectedtreepath = useSelector(
    (state) => state.mainpagedata.treepathselected
  );
  const dashboardMapState = useSelector((state) => state.mainpagedata.dashboardMapState);
  const path = useSelector((state) => state.mainpagedata.selectedpath);
  const tabpath = useSelector((state) => state.mainpagedata.selectedtabpath);
  const dateselected = useSelector((state) => state.mainpagedata.selecteddate);
  const projectname = useSelector(
    (state) => state.mainpagedata.selectedprojectname
  );
  const selectedtreedashboard = useSelector(
    (state) => state.mainpagedata.selectedtreedashboard
  );
  //const projectdetails = useSelector((state) => state.logindata.projectdata)
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const sdate_edate_selected = useSelector(
    (state) => state.mainpagedata.selecteddates
  );
  const selecteddates_dashboard = useSelector(
    (state) => state.mainpagedata.selecteddates_dashboard
  );
  const tagcollectionvalue = useSelector(
    (state) => state.mainpagedata.tagcollectionvalues
  );
    const tagcollectionvaluesnewjson = useSelector(
    (state) => state.mainpagedata.tagcollectionvaluesnewjson
  );
  const historicalvalues = useSelector(
    (state) => state.mainpagedata.historicalvalues
  );
  const livedataState = useSelector(
    (state) => state.mainpagedata.livedata
  );
  const [maintabs, setMaintabs] = useState([""]);
  const [pagesize, setPagesize] = useState(421); /*  */
  const [tabvalue, setTabvalue] = useState("");
  const [subtablist, setSubtablist] = useState([""]);
  const [sectabvalue, setSectabvalue] = useState("");
  const [pathselected, setPathselected] = useState([
    <Typography
      key="Dashboards"
      className="crumbs"
      style={{ fontSize: "16px", fontWeight: 700 }}
    >
      Plant
    </Typography>,
    <Typography
      key="Dashboards"
      className="crumbs"
      style={{ fontSize: "16px", fontWeight: 700 }}
    >
      Dashboard
    </Typography>,
    <Typography
      key="Dashboards"
      className="crumbs"
      style={{ fontSize: "16px", fontWeight: 700 }}
    >
      Overview
    </Typography>,
  ]);
  const [mainpath, setMainpath] = useState([]);
  const [dashboardjsonwidgets, setDashboardjsonwidgets] = useState();
  const [projectlist, setProjectlist] = useState([]);
  const [sldid, setSldid] = useState();
  const [allsubdashboards, setAllsubdashboards] = useState([]);
  const [allmaindashboards, setAllmaindashboards] = useState([]);
  const [openbackdrop, setOpenbackdrop] = useState(false);
  const [nodashboard, setNodashboard] = useState(false);
    // Runtime enriched widget list with attached series data
  const [processedWidgets, setProcessedWidgets] = useState([]);
  // Read-only layout derived from persisted gridmeta (w,h,x,y)
  const [displayLayout, setDisplayLayout] = useState([]); // [{i,x,y,w,h}]
  const ResponsiveGridLayout = React.useMemo(() => WidthProvider(Responsive), []);
  const [loadingWidgets, setLoadingWidgets] = useState(false);
  const [maximizedWidget, setMaximizedWidget] = useState(null);
  const [aggregatedDataPoints, setAggregatedDataPoints] = useState(null); // dashboardDataPoints API response
  const [historicLoaded, setHistoricLoaded] = useState(false);
  const [aggregatedLoaded, setAggregatedLoaded] = useState(false);
  const [initialLoadTimestamp] = useState(Date.now());


  //const [intervalref, setIntervalref] = useState(0);
  const { PermissionsArray: usrPrmns } = useSelector(
      (state) => state.logindata.userdetails
  );
  const intervalref = useRef();
  const livedatacallback = useCallback((res) => {
    let datajson = [];
    if (typeof res?.data?.data === "string") {
      try {
        datajson = JSON.parse(res.data.data);
      } catch (_e) {
        datajson = [];
      }
    } else if (Array.isArray(res?.data?.data)) {
      datajson = res.data.data;
    }
    dispatch(updatelivedata(datajson));
  }, [dispatch]);

  const collectLiveTagIdsFromWidgets = useCallback((widgets) => {
    if (!Array.isArray(widgets) || !widgets.length) {
      return [];
    }

    const tagSet = new Set();
    for (let i = 0; i < widgets.length; i++) {
      const tagProps = widgets[i]?.props?.extended?.tagprops;
      if (!Array.isArray(tagProps) || !tagProps.length) {
        continue;
      }

      for (let j = 0; j < tagProps.length; j++) {
        const tagId = tagProps[j]?.tagid;
        const tagId1 = tagProps[j]?.tagid1;

        if (tagId !== undefined && tagId !== null && String(tagId) !== "") {
          tagSet.add(String(tagId));
        }
        if (tagId1 !== undefined && tagId1 !== null && String(tagId1) !== "") {
          tagSet.add(String(tagId1));
        }
      }
    }

    return Array.from(tagSet).sort();
  }, []);

  const dashboardRequestedTagIds = useMemo(
    () => collectLiveTagIdsFromWidgets(dashboardjsonwidgets),
    [dashboardjsonwidgets, collectLiveTagIdsFromWidgets],
  );


    console.log("[Dashboard][Redux] selectedpath (updateselectedpath):", tabpath,path);
    console.log("[Dashboard][Redux] treepathselected (updatetreepathselected):", selectedtreepath);

  const timerfunction = useCallback((payloadTagIds) => {
    if (!Array.isArray(payloadTagIds) || !payloadTagIds.length) {
      return;
    }

    livedata(
      {
        tagids: payloadTagIds,
        overviewbarparameters: [],
      },
      livedatacallback,
    );
  }, [livedatacallback]);

  const dashboardcallback = (dashboardjson) => {
    // Check for error response from API
    if (dashboardjson?.success === false) {
      console.error("Dashboard fetch error:", dashboardjson.message);
      setNodashboard(false);
      setDashboardjsonwidgets([]);
      setProcessedWidgets([]);
      setDisplayLayout([]);
      setOpenbackdrop(false);
      alert(dashboardjson.message || "Failed to load dashboard. Please try again.");
      return;
    }

    if (dashboardjson?.dashboardjson?.hasOwnProperty("DashboardJSON")) {
      const widgetlist = dashboardjson.dashboardjson.DashboardJSON.widgetlist;

      // Check if widgetlist exists and is a valid array
      if (Array.isArray(widgetlist) && widgetlist.length > 0) {
        setDashboardjsonwidgets(widgetlist);
        setNodashboard(true);
        var taglist = [];
        for (let i = 0; i < widgetlist.length; i++) {
          var extendendprops = widgetlist[i]?.props?.extended;
          //console.log("tag array ",extendendprops.tagprops)

          if (extendendprops && Array.isArray(extendendprops.tagprops) && extendendprops.tagprops.length > 0) {
             for (let j = 0; j < extendendprops.tagprops.length; j++) {
                taglist.push(extendendprops.tagprops[j].tagname);
              }
          }
         
        }
        var uniqtaglist = [...new Set(taglist)];
        const payloadTagIds = collectLiveTagIdsFromWidgets(widgetlist);

        timerfunction(payloadTagIds);
        if (intervalref.current) {
          clearInterval(intervalref.current);
          intervalref.current = null;
        }
        var intervalId = setInterval(() => timerfunction(payloadTagIds), 60000);
        //console.log("intervalId ",intervalId)
        intervalref.current = intervalId;

        var currentdashboardtags = widgetlist;
        var tagidarray = [];
        var payloadnamearray = [];

        for (var i = 0; i < currentdashboardtags.length; i++) {
          var tagpropsarray = currentdashboardtags[i]?.props?.extended?.tagprops;
          if (tagpropsarray && Array.isArray(tagpropsarray) && tagpropsarray.length > 0) {
            for (var j = 0; j < tagpropsarray.length; j++) {
              tagidarray.push(tagpropsarray[j].tagid);
              payloadnamearray.push(tagpropsarray[j].tagname);
            }
          }
        }

        dispatch(updatedashboardjsontags(tagidarray));
        // Trigger initial per-widget data fetch (live + historic) once widgets arrive
        fetchWidgetData(widgetlist);
      } else {
        // DashboardJSON exists but widgetlist is empty or missing - clear old data
        setDashboardjsonwidgets([]);
        setProcessedWidgets([]);
        setDisplayLayout([]);
        setNodashboard(tabvalue === "SLD");
        // Clear any existing live data interval
        if (intervalref.current) {
          clearInterval(intervalref.current);
          intervalref.current = null;
        }
      }
    } else {
      // No DashboardJSON property at all - clear everything
      setDashboardjsonwidgets([]);
      setProcessedWidgets([]);
      setDisplayLayout([]);
      setNodashboard(false);
      if (intervalref.current) {
        clearInterval(intervalref.current);
        intervalref.current = null;
      }
    }
    setOpenbackdrop(false);
  };

  const datacallback = (responce) => {
    if (responce !== undefined && responce !== null) {
      var mergedobjectcollection = {
        ...tagcollectionreplica,
        ...responce.data,
      }; 
      dispatch(updatehistoricalvalue(responce.data));
    }
  };
  const datacallback1 = (responce) => {
    if (responce !== undefined && responce !== null) {
      var mergedobjectcollection = {
        ...tagcollectionreplica,
        ...responce.data,
      }; //value of common keys from 2nd object responce overwrites values of common keys from 1st object
      dispatch(updatetagcollectionvalue(mergedobjectcollection));
      //dispatch(updatehistoricalvalue(responce.data))
    }
  };
  const datacallback2 = (responce) => {
    var responscedata = responce;
    dispatch(
      updatetagcollectionvaluenewjson(responscedata?.data?.data?.tagdatamap)
    );
    dispatch(
      updatetagaliascollectionvaluenewjson(
        responscedata?.data?.data?.aliasdatamap
      )
    );
  };
  const callbackprojects = (res) => {
    setProjectlist(res.data);
  };
  useEffect(() => {
    return () => {
      if (intervalref.current !== null) {
        clearInterval(intervalref.current);
      }
    };
  }, []);
    const callback = (response) => {
      console.log('getDashboardDataPoints response:', response);
    };
  useEffect(() => {
     // Hardcoded parameters
    const sdate = '2025-09-30T18:30:00.000Z';
    const edate = '2025-10-01T18:29:59.999Z';
    const tagidsArr = [
      { tagid: '160744107', operation: 'SUM' },
      { tagid: '160744106', operation: 'SUM' }
    ];
    const datetype = 'Last 24 hours';
    // Callback to handle response
    getDashboardDataPoints(sdate, edate, tagidsArr, datetype, callback);
    //console.log("dashboardjsonwidgets details ",dashboardjsonwidgets
    if (sectabvalue === "Overview") {
      datacollect(generalconfig,dashboardjsonwidgets, "Dashboard", selecteddates_dashboard);
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Dashboard",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
    } else if (sectabvalue === "Plant Overview") {
      //console.log("dateselected in historical",dateselected)
      //console.log("dashboardjsonwidgets in historical",dashboardjsonwidgets)
      // if(dashboardjsonwidgets != undefined && dashboardjsonwidgets != "") {
      //     var taglist = []
      //     //for(let i=0; i<dashboardjsonwidgets.length; i++) {
      //         if(dashboardjsonwidgets[0].props.extended.datatype === "hist") {
      //             taglist.push(dashboardjsonwidgets[0])
      //         }
      //     //}
      //     console.log("taglist in historicalOverview",taglist)
      //     getdashboardhistoricaldata(taglist, sdate_edate_selected.startdates, sdate_edate_selected.enddates, "day", dateselected, 'Any', datacallback)
      // }
      datacollect(generalconfig,dashboardjsonwidgets, "Dashboard", selecteddates_dashboard);
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Dashboard",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
    } else if (sectabvalue === "Overview-Mumbai") {
      //console.log("Overview-Mumbai sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,
        dashboardjsonwidgets,
        "Overview-Mumbai",
        selecteddates_dashboard
      );
      //console.log("Energy Analytics after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Energy Analytics",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
    } else if (sectabvalue === "Energy Analytics") {
      //console.log("Energy Analytics sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,
        dashboardjsonwidgets,
        "Energy Analytics",
        selecteddates_dashboard
      );
      //console.log("Energy Analytics after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Energy Analytics",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
    } else if (sectabvalue === "INV-1 Overview") {
      //console.log("Energy Analytics sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,
        dashboardjsonwidgets,
        "INV-1 Overview",
        selecteddates_dashboard
      );
      //console.log("Energy Analytics after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "INV-1 Overview",
        userdetails.Organizationid,
          userdetails.Projectid,
        datacallback1
      );
    } else if (sectabvalue === "Overview-ABT") {
      //console.log("Energy Analytics sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,
        dashboardjsonwidgets,
        "Overview-ABT",
        selecteddates_dashboard
      );
      //console.log("Energy Analytics after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Overview-ABT",
        userdetails.Organizationid,
          userdetails.Projectid,
        datacallback1
      );
    } else if (sectabvalue === "Energy Accounting") {
      //console.log("Energy Accounting sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,
        dashboardjsonwidgets,
        "Energy Accounting",
        selecteddates_dashboard
      );
      //console.log("Energy Accounting after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Energy Accounting",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
      //getdashboarddata(['tag1', 'tag2', 'tag3'], '13-05-2024 00:00:00', '13-05-2024 23:59:59', dateselected, 'Energy Accounting', datacallback1)
    } else if (sectabvalue === "Power Quality") {
      //console.log("Power Quality sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,
        dashboardjsonwidgets,
        "Power Quality",
        selecteddates_dashboard
      );
      //console.log("Power Quality after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Power Quality",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
      //getdashboarddata(['tag1', 'tag2', 'tag3'], '13-05-2024 00:00:00', '13-05-2024 23:59:59', dateselected, 'Power Quality', datacallback1)
    } else if (sectabvalue === "Status Table") {
      //console.log("Status Table sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,
        dashboardjsonwidgets,
        "Status Table",
        selecteddates_dashboard
      );
      //console.log("Status Table after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Status Table",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
      //getdashboarddata(['tag1', 'tag2', 'tag3'], '13-05-2024 00:00:00', '13-05-2024 23:59:59', dateselected, 'Power Quality', datacallback1)
    } 
    // else if (sectabvalue === "Dashboard New") {
    //   //console.log("Status Table sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
    //   datacollect(generalconfig,
    //     dashboardjsonwidgets,
    //     "Dashboard New",
    //     selecteddates_dashboard
    //   );
    //   //console.log("Status Table after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
    //   getdashboarddata(
    //     tag_collection_query_db,
    //     selecteddates_dashboard.startdates,
    //     selecteddates_dashboard.enddates,
    //     flag,
    //     dateselected,
    //     "Dashboard New",
    //     userdetails.Organizationid,
    //     userdetails.Projectid,
    //     datacallback1
    //   );
    //   //getdashboarddata(['tag1', 'tag2', 'tag3'], '13-05-2024 00:00:00', '13-05-2024 23:59:59', dateselected, 'Power Quality', datacallback1)
    // } 
    else if (sectabvalue === "Environment") {
      //console.log("Environment sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,dashboardjsonwidgets, "Environment", selecteddates_dashboard);
      //console.log("Environment after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Environment",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
      //getdashboarddata(['tag1', 'tag2', 'tag3'], '13-05-2024 00:00:00', '13-05-2024 23:59:59', dateselected, 'Environment', datacallback1)
    } else if (sectabvalue === "Social") {
      //console.log("Social sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,dashboardjsonwidgets, "Social", selecteddates_dashboard);
      //console.log("Social after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Social",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
      //getdashboarddata(['tag1', 'tag2', 'tag3'], '13-05-2024 00:00:00', '13-05-2024 23:59:59', dateselected, 'Social', datacallback1)
    } else if (sectabvalue === "Governance") {
      //console.log("Governance sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,dashboardjsonwidgets, "Governance", selecteddates_dashboard);
      //console.log("Governance after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Governance",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
      //getdashboarddata(['tag1', 'tag2', 'tag3'], '13-05-2024 00:00:00', '13-05-2024 23:59:59', dateselected, 'Governance', datacallback1)
    }
    else if(sectabvalue === 'Digital Twin') {
      setSubtablist(['Digital Twin','Thermal Management'])
      setTabvalue('Digital Twin')
      setSectabvalue('Digital Twin')
      
    }
    else if(sectabvalue === 'Thermal Management') {
      setSubtablist(['Digital Twin','Thermal Management'])
      setTabvalue('Thermal Management')
      setSectabvalue('Thermal Management')
     
    }
     else if (sectabvalue === "Periodic Maintenance") {
      //console.log("Periodic Maintenance sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,
        dashboardjsonwidgets,
        "Periodic Maintenance",
        selecteddates_dashboard
      );
      //console.log("Periodic Maintenance after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Periodic Maintenance",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
      //getdashboarddata(['tag1', 'tag2', 'tag3'], '13-05-2024 00:00:00', '13-05-2024 23:59:59', dateselected, 'Periodic Maintenance', datacallback1)
    } else if (sectabvalue === "Diagnostics") {
      //console.log("Periodic Maintenance sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,dashboardjsonwidgets, "Diagnostics", selecteddates_dashboard);
      //console.log("Periodic Maintenance after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Diagnostics",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
      //getdashboarddata(['tag1', 'tag2', 'tag3'], '13-05-2024 00:00:00', '13-05-2024 23:59:59', dateselected, 'Periodic Maintenance', datacallback1)
    } else {
      //console.log("Status Table sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
      datacollect(generalconfig,
        dashboardjsonwidgets,
        "Dashboard New",
        selecteddates_dashboard
      );
      
      getdashboarddata(
        tag_collection_query_db,
        selecteddates_dashboard.startdates,
        selecteddates_dashboard.enddates,
        flag,
        dateselected,
        "Status Table",
        userdetails.Organizationid,
        userdetails.Projectid,
        datacallback1
      );
      //gethistoricaldata
      if (dashboardjsonwidgets != undefined && dashboardjsonwidgets != "") {
        var taglist = [];
        for (let i = 0; i < dashboardjsonwidgets.length; i++) {
          //if (dashboardjsonwidgets[i].props.extended.datatype === "hist") {
          taglist.push(dashboardjsonwidgets[i]);
          //}
        }
        gethistoricaldata(
          taglist,
          selecteddates_dashboard.startdates,
          selecteddates_dashboard.enddates,
          flag,
          dateselected,
          "Diagnostics",
          userdetails.Organizationid,
          userdetails.Projectid == "All" ? projectname : userdetails.Projectid,
          datacallback2
        );
      }
    }
    // else {
    //   console.log("dateselected in historical", dateselected);
    //   console.log("dashboardjsonwidgets in historical", dashboardjsonwidgets);
    //   if (sectabvalue != "") {
    //     //console.log("Periodic Maintenance sending dashboardjsonwidgets",dashboardjsonwidgets,"selecteddates_dashboard",selecteddates_dashboard)
    //     datacollect(generalconfig,dashboardjsonwidgets, "", selecteddates_dashboard);
    //     //console.log("Periodic Maintenance after data collect before sending query********tag_collection_query_db***********",tag_collection_query_db,"tagcollection",tagcollection,"flag",flag)
    //     getdashboarddata(
    //       tag_collection_query_db,
    //       selecteddates_dashboard.startdates,
    //       selecteddates_dashboard.enddates,
    //       flag,
    //       dateselected,
    //       "",
    //       datacallback1
    //     );
    //     //getdashboarddata(['tag1', 'tag2', 'tag3'], '13-05-2024 00:00:00', '13-05-2024 23:59:59', dateselected, 'Periodic Maintenance', datacallback1)
    //   }
    //   if (dashboardjsonwidgets != undefined && dashboardjsonwidgets != "") {
    //     var taglist = [];
    //     for (let i = 0; i < dashboardjsonwidgets.length; i++) {
    //       if (dashboardjsonwidgets[i].props.extended.datatype === "hist") {
    //         taglist.push(dashboardjsonwidgets[i]);
    //       }
    //     }
    //     console.log("taglist in historical", taglist);
    //     getdashboardhistoricaldata(
    //       taglist,
    //       selecteddates_dashboard.startdates,
    //       selecteddates_dashboard.enddates,
    //       "day",
    //       dateselected,
    //       "Any",
    //       datacallback
    //     );
    //   }
    // }
  }, [sdate_edate_selected, dashboardjsonwidgets, generalconfig]); /*sdate_edate_selected,dashboardjsonwidgets*/
 
  useEffect(() => {
    if (overviewstate) {
      setPagesize(339);
    } else {
      setPagesize(304);
    }
  }, [overviewstate]);
  useEffect(() => {
    var newpath = [];
    newpath.push(tabvalue);
    newpath.push(sectabvalue);
    dispatch(updatetabpath(newpath));
  }, [sectabvalue, tabvalue]);
  function getgeneralconfigcallback(res){
     dispatch(updategeneralconfig(res.data.configinfo))
  }
  useEffect(()=>{
    if(userdetails.PermissionsArray.includes("PJGC23")){
        getGeneralConfiguration(getgeneralconfigcallback)
    }
  },[projectname])
  // useEffect(() => {
   
  //   if (selectedtreedashboard.hasOwnProperty("maindashboardlist")) {
  //     var maintabs = [];
  //     var subtabs = [];
  //     var panelname = "";
  //     if (selectedtreedashboard.maindashboardlist != undefined) {
  //       //console.log("selectedtreedashboard.maindashboardlist ",selectedtreedashboard.maindashboardlist)
  //       if (selectedtreedashboard.maindashboardlist.length) {
  //         for (
  //           let i = 0;
  //           i < selectedtreedashboard.maindashboardlist.length;
  //           i++
  //         ) {
  //           maintabs.push(selectedtreedashboard.maindashboardlist[i].label);
  //         }
  //         if (Array.isArray(selectedtreedashboard.subdashboardlist) && selectedtreedashboard.subdashboardlist.length>0 && Array.isArray(selectedtreedashboard.subdashboardlist[0]) && selectedtreedashboard.subdashboardlist[0].length) {
  //           for (
  //             let j = 0;
  //             j < selectedtreedashboard.subdashboardlist[0].length;
  //             j++
  //           ) {
  //             subtabs.push(selectedtreedashboard.subdashboardlist[0][j].label);
  //             if (j === 0) {
  //               panelname =
  //                 selectedtreedashboard.subdashboardlist[0][j].pagename;
  //             }
  //           }
  //           setMaintabs(maintabs);
  //           setSubtablist(subtabs);
  //           setTabvalue(maintabs[0]);
  //           setSectabvalue(subtabs[0]);
  //           setAllsubdashboards(selectedtreedashboard.subdashboardlist);
  //           setAllmaindashboards(selectedtreedashboard.maindashboardlist);
  //           if (userdetails.Projectid === "All") {
  //             if (projectname !== "All") {
  //               getdashboarddetails(
  //                 panelname,
  //                 userdetails.Organizationid,
  //                 projectname,
  //                 dashboardcallback
  //               );
  //             } else {
  //               getdashboarddetails(
  //                 panelname,
  //                 userdetails.Organizationid,
  //                 userdetails.Projectid,
  //                 dashboardcallback
  //               );
  //             }
  //           } else {
  //             getdashboarddetails(
  //               panelname,
  //               userdetails.Organizationid,
  //               userdetails.Projectid,
  //               dashboardcallback
  //             );
  //           }
  //           //getdashboarddetails(panelname, userdetails.Organizationid, userdetails.Projectid, dashboardcallback)
  //           setOpenbackdrop(true);
  //         }
  //       }
  //     }
  //   }
  // }, [selectedtreedashboard]);

  useEffect(() => {
    if (selectedtreedashboard.hasOwnProperty("maindashboardlist")) {
      // If both maindashboardlist and subdashboardlist are empty, reset all tab states
      if (
        !selectedtreedashboard.maindashboardlist ||
        selectedtreedashboard.maindashboardlist.length === 0 ||
        !Array.isArray(selectedtreedashboard.subdashboardlist) ||
        selectedtreedashboard.subdashboardlist.length === 0 ||
        !Array.isArray(selectedtreedashboard.subdashboardlist[0]) ||
        selectedtreedashboard.subdashboardlist[0].length === 0
      ) {
        setMaintabs([]);
        setSubtablist([]);
        setTabvalue("");
        setSectabvalue("");
        setAllsubdashboards([]);
        setAllmaindashboards([]);
        return;
      }
      var maintabs = [];
      var subtabs = [];
      var panelname = "";
      if (selectedtreedashboard.maindashboardlist != undefined) {
        //console.log("selectedtreedashboard.maindashboardlist ",selectedtreedashboard.maindashboardlist)
        if (selectedtreedashboard.maindashboardlist.length) {
      for (
        let i = 0;
        i < selectedtreedashboard.maindashboardlist.length;
        i++
      ) {
        maintabs.push(selectedtreedashboard.maindashboardlist[i].label);
      }
          if (selectedtreedashboard.subdashboardlist[0].length) {
      for (
        let j = 0;
        j < selectedtreedashboard.subdashboardlist[0].length;
        j++
      ) {
        subtabs.push(selectedtreedashboard.subdashboardlist[0][j].label);
        if (j === 0) {
          panelname = 
            selectedtreedashboard.subdashboardlist[0][j].pagename;
        }
      }
      setMaintabs(maintabs);
      setSubtablist(subtabs);
      setTabvalue(maintabs[0]);
      setSectabvalue(subtabs[0]);
      setAllsubdashboards(selectedtreedashboard.subdashboardlist);
      setAllmaindashboards(selectedtreedashboard.maindashboardlist);
      if (userdetails.Projectid === "All") {
        if (projectname !== "All") {
          getdashboarddetails(
            panelname,
            userdetails.Organizationid,
            projectname,
            dashboardcallback
          );
        } else {
          getdashboarddetails(
            panelname,
            userdetails.Organizationid,
            userdetails.Projectid,
            dashboardcallback
          );
        }
      } else {
        getdashboarddetails(
          panelname,
          userdetails.Organizationid,
          userdetails.Projectid,
          dashboardcallback
        );
      }
            //getdashboarddetails(panelname, userdetails.Organizationid, userdetails.Projectid, dashboardcallback)
      setOpenbackdrop(true);
          }
        }
      }
    }
  }, [selectedtreedashboard]);
  
  //  useEffect(() => {
   
  //   if (selectedtreedashboard.hasOwnProperty("maindashboardlist")) {
  //      // If both maindashboardlist and subdashboardlist are empty, reset all tab states
  //     if (
  //       !selectedtreedashboard.maindashboardlist ||
  //       selectedtreedashboard.maindashboardlist.length === 0 ||
  //       !Array.isArray(selectedtreedashboard.subdashboardlist) ||
  //       selectedtreedashboard.subdashboardlist.length === 0 ||
  //       !Array.isArray(selectedtreedashboard.subdashboardlist[0]) ||
  //       selectedtreedashboard.subdashboardlist[0].length === 0
  //     ) {
  //       setMaintabs([]);
  //       setSubtablist([]);
  //       setTabvalue("");
  //       setSectabvalue("");
  //       setAllsubdashboards([]);
  //       setAllmaindashboards([]);
  //       return;
  //     }

  //     var maintabs = [];
  //     var subtabs = [];
  //     var panelname = "";
  //     if (selectedtreedashboard.maindashboardlist != undefined) {
  //       if (selectedtreedashboard.maindashboardlist.length) {
  //         for (let i = 0;i < selectedtreedashboard.maindashboardlist.length;i++) {
  //           let atLeastOneSubDashboardExists = false;
  //           for (let j = 0;j < selectedtreedashboard.subdashboardlist[i].length;j++) {
  //               if(selectedtreedashboard.subdashboardlist[i][j] != undefined && selectedtreedashboard.subdashboardlist[i][j]!= null && selectedtreedashboard.subdashboardlist[i][j].hasOwnProperty("dashboard_pro")){
  //                 console.log("selectedtreedashboard.maindashboardlist ",selectedtreedashboard.maindashboardlist,"dashboardMapState",dashboardMapState,"selectedtreedashboard.subdashboardlist[i][j]",selectedtreedashboard.subdashboardlist[i][j])
  //                   let currentDashboardMap = dashboardMapState[selectedtreedashboard.subdashboardlist[i][j]["dashboard_pro"]]
  //                   if(currentDashboardMap != undefined && currentDashboardMap!= null && currentDashboardMap.hasOwnProperty("permission")){
  //                       let currentPermission = currentDashboardMap["permission"]
  //                       if(userdetails.PermissionsArray.includes(currentPermission)){
  //                           atLeastOneSubDashboardExists = true;
  //                           break;
  //                       }
  //                   }
  //               }
  //           }
  //           if(atLeastOneSubDashboardExists){
  //               maintabs.push(selectedtreedashboard.maindashboardlist[i].label);
  //           }
  //         }

  //         if (selectedtreedashboard.subdashboardlist[0].length) {
  //           for (let j = 0;j < selectedtreedashboard.subdashboardlist[0].length;j++) {
  //             let isPermissionExists = false;
  //             if(selectedtreedashboard.subdashboardlist[0][j] != undefined && selectedtreedashboard.subdashboardlist[0][j]!= null && selectedtreedashboard.subdashboardlist[0][j].hasOwnProperty("dashboard_pro")){
  //                   let currentDashboardMap = dashboardMapState[selectedtreedashboard.subdashboardlist[0][j]["dashboard_pro"]]
  //                   if(currentDashboardMap != undefined && currentDashboardMap!= null && currentDashboardMap.hasOwnProperty("permission")){
  //                       let currentPermission = currentDashboardMap["permission"]
  //                       if(userdetails.PermissionsArray.includes(currentPermission)){
  //                           isPermissionExists = true;
  //                       }
  //                   }
  //               }
  //               if(isPermissionExists){
  //                   subtabs.push(selectedtreedashboard.subdashboardlist[0][j].label);
  //                   if (j === 0) {
  //                     panelname =  selectedtreedashboard.subdashboardlist[0][j].pagename;
  //                   }
  //               }
  //           }
  //           setMaintabs(maintabs);
  //           setSubtablist(subtabs);
  //           setTabvalue(maintabs[0]);
  //           setSectabvalue(subtabs[0]);
  //           setAllsubdashboards(selectedtreedashboard.subdashboardlist);
  //           setAllmaindashboards(selectedtreedashboard.maindashboardlist);
  //           if (userdetails.Projectid === "All") {
  //             if (projectname !== "All") {
  //               getdashboarddetails(
  //                 panelname,
  //                 userdetails.Organizationid,
  //                 projectname,
  //                 dashboardcallback
  //               );
  //             } else {
  //               getdashboarddetails(
  //                 panelname,
  //                 userdetails.Organizationid,
  //                 userdetails.Projectid,
  //                 dashboardcallback
  //               );
  //             }
  //           } else {
  //             getdashboarddetails(
  //               panelname,
  //               userdetails.Organizationid,
  //               userdetails.Projectid,
  //               dashboardcallback
  //             );
  //           }
  //           //getdashboarddetails(panelname, userdetails.Organizationid, userdetails.Projectid, dashboardcallback)
  //           setOpenbackdrop(true);
  //         }
  //       }
  //     }
  //   }
  // }, [selectedtreedashboard,dashboardMapState]);

  useEffect(() => {}, [selectedtreepath]);
  const handletabchange = (event, newValue) => {
    //console.log("maintab select ", newValue);
    var newpath = [];
    if (newValue != "") {
      // Clear old widgets immediately to prevent stuck previous tab view
      setDashboardjsonwidgets([]);
      setProcessedWidgets([]);
      setDisplayLayout([]);
      setLoadingWidgets(true);
      
      var panel = "";
      for (let i = 0; i < allmaindashboards.length; i++) {
        if (newValue === allmaindashboards[i].label) {
          //console.log("allsubdashboards ", allsubdashboards[i]);
          var subtabsli = [];
          for (let j = 0; j < allsubdashboards[i].length; j++) {
            subtabsli.push(allsubdashboards[i][j].label);
            if (j === 0) {
              panel = allsubdashboards[i][j].pagename;
            }
          }
          setSubtablist(subtabsli);
          setSectabvalue(subtabsli[0]);
          newpath.push(newValue);
          newpath.push(subtabsli[0]);
          if (userdetails.Projectid === "All") {
            if (projectname !== "All") {
              getdashboarddetails(
                panel,
                userdetails.Organizationid,
                projectname,
                dashboardcallback
              );
            } else {
              getdashboarddetails(
                panel,
                userdetails.Organizationid,
                userdetails.Projectid,
                dashboardcallback
              );
            }
          } else {
            getdashboarddetails(
              panel,
              userdetails.Organizationid,
              userdetails.Projectid,
              dashboardcallback
            );
          }
          //getdashboarddetails(panel, userdetails.Organizationid, userdetails.Projectid, dashboardcallback)
          setOpenbackdrop(true);
          break;
        }
      }
    }
    dispatch(updatetabpath(newpath));
    setTabvalue(newValue);
  };
  const handlesectabchange = (event, newValue) => {
    var newchange = Array.from(pathselected);
    newchange[newchange.length - 1] = (
      <Typography
        key={newValue}
        className="crumbs"
        style={{ fontSize: "16px", fontWeight: 700 }}
      >
        {newValue}
      </Typography>
    );
    setPathselected(newchange);
    setSectabvalue(newValue);
    
    // Clear old widgets immediately to prevent stuck previous tab view
    setDashboardjsonwidgets([]);
    setProcessedWidgets([]);
    setDisplayLayout([]);
    setLoadingWidgets(true);
    setAggregatedDataPoints(null);
    
    //Energy Management
    ////console.log("tabvalue ", newValue, tabvalue);
    var panel = "";
    for (let i = 0; i < allmaindashboards.length; i++) {
      if (tabvalue === allmaindashboards[i].label) {
        for (let j = 0; j < allsubdashboards[i].length; j++) {
          if (newValue === allsubdashboards[i][j].label) {
            panel = allsubdashboards[i][j].pagename;
            break;
          }
        }
      }
    }
    //console.log("sub tab panel ", panel);
    if (tabvalue !== "Project SLD") {
      if (userdetails.Projectid === "All") {
        if (projectname !== "All") {
          getdashboarddetails(
            panel,
            userdetails.Organizationid,
            projectname,
            dashboardcallback
          );
        } else {
          getdashboarddetails(
            panel,
            userdetails.Organizationid,
            userdetails.Projectid,
            dashboardcallback
          );
        }
      } else {
        getdashboarddetails(
          panel,
          userdetails.Organizationid,
          userdetails.Projectid,
          dashboardcallback
        );
      }
      //getdashboarddetails(panel, userdetails.Organizationid, userdetails.Projectid, dashboardcallback)
      setOpenbackdrop(true);
      if (newValue === "Status Table") {
      } else {
        getdashboarddata(
          ["tag1", "tag2", "tag3"],
          "13-05-2024 00:00:00",
          "13-05-2024 23:59:59",
          dateselected,
          newValue,
          userdetails.Organizationid,
          userdetails.Projectid,
          datacallback
        );
      }
    } else {
      for (let i = 0; i < projectlist.length; i++) {
        if (projectlist[i].projectName === newValue) {
          setSldid(projectlist[i]._guiId);
        }
      }
    }
  };
  const maximizecallback = (maxiwidgetjson, maxmin) => {
    if (maxmin) {
      setMaximizedWidget(maxiwidgetjson || null);
      return;
    }
    setMaximizedWidget(null);
  };

  const getWidgetDatapoints = (widget) => {
    const extended = widget?.props?.extended || {};
    if (Array.isArray(extended.datapoints) && extended.datapoints.length) {
      return extended.datapoints;
    }
    if (Array.isArray(extended.tagprops) && extended.tagprops.length) {
      return extended.tagprops;
    }
    return [];
  };

  const getDatapointMode = (datapoint, extended) => {
    const rawMode = datapoint?.dataType || extended?.dataType || extended?.datatype || 'live';
    return String(rawMode).toLowerCase() === 'historic' || String(rawMode).toLowerCase() === 'hist'
      ? 'historic'
      : 'live';
  };

  const widgetHasHistoricDatapoints = (widget) => {
    const extended = widget?.props?.extended || {};
    return getWidgetDatapoints(widget).some((datapoint) => getDatapointMode(datapoint, extended) === 'historic');
  };

  // Helper to build tagids payload for dashboardDataPoints
  const buildTagIdsForDataPoints = (widgets) => {
    if (!Array.isArray(widgets)) return [];
    const list = [];
    widgets.forEach(w => {
      const ext = w?.props?.extended || {};
      const datapoints = getWidgetDatapoints(w);
      datapoints.forEach(tp => {
        if (getDatapointMode(tp, ext) !== 'historic') return;
        const raw = tp.tagid || tp.tagId || tp.id;
        if (raw != null) {
          const op = (tp.storageSelection || tp.operation || tp.aggregate || tp.aggregation || 'AVG').toUpperCase();
          list.push({ tagid: String(raw), operation: op });
        }
      });
    });
    const uniq = new Map();
    list.forEach(e => uniq.set(e.tagid + '|' + e.operation, e));
    return Array.from(uniq.values());
  };

  // Direct fetch utility to call dashboardDataPoints with explicit encoded tagids array
  const rawDashboardDataPoints = async (sdate, edate, datetype, tagidsArray) => {
    try {
      const tagidsParam = encodeURIComponent(JSON.stringify(tagidsArray));
      const url = `${window.location.origin.replace(/\:$|$/,'')}/dashboard/dashboardDataPoints?sdate=${encodeURIComponent(sdate)}&edate=${encodeURIComponent(edate)}&datetype=${encodeURIComponent(datetype)}&tagids=${tagidsParam}`;
      const resp = await fetch(url, { method: 'GET' });
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const data = await resp.json();
  setAggregatedLoaded(true);
      return data;
    } catch (e) {
      return null;
    }
  };

  // Build chart series using aggregated datapoints first, then historic/live backend sources
  const buildWidgetSeries = (widget) => {
    const extended = widget?.props?.extended || {};
    const datapoints = getWidgetDatapoints(widget);
    if (!datapoints.length) {
     
      return [];
    }
    const liveArray = Array.isArray(livedataState) ? livedataState : [];
    return datapoints.map(tp => {
      const tagIdRaw = tp.tagid || tp.tagId || tp.id;
      const tagId = tagIdRaw != null ? String(tagIdRaw) : undefined;
      if (!tagId) {
        return { id: undefined, name: 'Unknown', points: [] };
      }
      const datapointMode = getDatapointMode(tp, extended);
      let points = [];
      let fetchSource = null;
      
      if (datapointMode === 'historic') {
        // Aggregated historic response for historic datapoints only
        if (aggregatedDataPoints) {
          if (Array.isArray(aggregatedDataPoints.data)) {
            const aggEntry = aggregatedDataPoints.data.find(d => String(d.tagid) === tagId);
            if (aggEntry && Array.isArray(aggEntry.points) && aggEntry.points.length) {
              points = aggEntry.points
                .filter(p => p && (p.timestamp || p.time || p.x) != null && (p.value != null || p.y != null))
                .map(p => {
                  const t = p.timestamp || p.time || p.x;
                  const numericT = Number(t);
                  const ts = numericT * (String(t).length < 13 ? 1000 : 1);
                  const valRaw = p.value ?? p.y;
                  const val = typeof valRaw === 'number' ? valRaw : Number(valRaw);
                  return { x: ts, y: val };
                })
                .filter(p => !isNaN(p.x) && !isNaN(p.y));
              fetchSource = 'historic';
            }
          } else {
            const arr = aggregatedDataPoints[tagId];
            if (Array.isArray(arr) && arr.length) {
              points = arr
                .filter(p => p && (p.x != null || p.timestamp != null || p.time != null) && (p.y != null || p.value != null))
                .map(p => {
                  const t = p.x || p.timestamp || p.time;
                  const numericT = Number(t);
                  const ts = numericT * (String(t).length < 13 ? 1000 : 1);
                  const valRaw = p.y ?? p.value;
                  const val = typeof valRaw === 'number' ? valRaw : Number(valRaw);
                  return { x: ts, y: val };
                })
                .filter(p => !isNaN(p.x) && !isNaN(p.y));
              fetchSource = 'historic';
            }
          }
        }
        if (!points.length && historicalvalues && Array.isArray(historicalvalues[tagId])) {
          points = historicalvalues[tagId]
            .filter(p => p && (p.timestamp || p.time) != null && p.value != null)
            .map(p => ({
              x: (p.timestamp || p.time) * (String(p.timestamp || p.time).length < 13 ? 1000 : 1),
              y: typeof p.value === 'number' ? p.value : Number(p.value)
            }))
            .filter(p => !isNaN(p.x) && !isNaN(p.y));
          fetchSource = 'historic';
        }
      } else {
        const liveEntry = livedataState ? livedataState[tagId] : undefined;
        if (!points.length && Array.isArray(liveEntry)) {
          points = liveEntry
            .map(p => ({ x: (p.timestamp || p.time || Date.now()), y: Number(p.value ?? p.y ?? p) }))
            .filter(p => !isNaN(p.x) && !isNaN(p.y));
          fetchSource = 'live';
        } else if (!points.length && liveArray.length) {
          points = liveArray
            .filter((entry) => {
              const entryTagId = entry?.TagId || entry?.tagid || entry?.TagID;
              return entryTagId != null && String(entryTagId) === tagId;
            })
            .map((entry) => {
              const rawTs = entry?.timestamp || entry?.time || Date.now();
              const numTs = Number(rawTs);
              const ts = !Number.isNaN(numTs)
                ? numTs * (String(numTs).length < 13 ? 1000 : 1)
                : Date.now();
              return {
                x: ts,
                y: Number(entry?.value ?? entry?.val ?? entry?.y),
              };
            })
            .filter((point) => !isNaN(point.x) && !isNaN(point.y));
          if (points.length) fetchSource = 'live';
        } else if (!points.length) {
          // Scalars from livedataState or collection maps
          let scalar;
            if (liveEntry && typeof liveEntry === 'object' && liveEntry.value != null) {
              scalar = liveEntry.value;
              fetchSource = 'live';
            }
            else if (typeof liveEntry === 'number') {
              scalar = liveEntry;
              fetchSource = 'live';
            }
            else if (tagcollectionvaluesnewjson && tagcollectionvaluesnewjson[tagId] != null) {
              scalar = tagcollectionvaluesnewjson[tagId];
              fetchSource = 'live';
            }
            else if (tagcollectionvalue && tagcollectionvalue[tagId] != null) {
              scalar = tagcollectionvalue[tagId];
              fetchSource = 'live';
            }
          if (scalar != null && isFinite(Number(scalar))) {
            points = [{ x: Date.now(), y: Number(scalar) }];
          }
        }
      }
      
      
      return {
        id: tagId,
        tagid: tagId,
        name: tp.legendname || tp.displayname || tp.tagname || String(tagId),
        operation: (tp.storageSelection || tp.operation || tp.aggregate || tp.aggregation || 'AVG').toUpperCase(),
        fetchSource,
        configuredSource: datapointMode,
        points
      };
    });
  };

  // Enrich raw widget list with runtimeSeries
  const enrichWidgets = (widgets) => {
    if (!Array.isArray(widgets)) return [];
    return widgets.map(w => ({ ...w, runtimeSeries: buildWidgetSeries(w) }));
  };

  // Fetch live + historic data for widgets (similar to test workflow)
  const fetchWidgetData = (widgets) => {
    if (!Array.isArray(widgets) || !widgets.length) {
      setLoadingWidgets(false);
      return;
    }
    setLoadingWidgets(true);
    
    // Immediate live refresh
    const payloadTagIds = widgets.flatMap((w) => {
        const ext = w.props?.extended || {};
        const source =
          Array.isArray(ext.datapoints) && ext.datapoints.length
            ? ext.datapoints
            : ext.tagprops || [];
        return source
          .map((item) => String(item.tagid || item.key || item.id))
          .filter(Boolean);
      });
      
    if (payloadTagIds.length > 0) {
      timerfunction(payloadTagIds);
    }
    
    // Collect historic-only widgets
    const histWidgets = widgets.filter(w => w?.props?.extended?.datatype === 'hist');
    if (histWidgets.length) {
      gethistoricaldata(
        histWidgets,
        selecteddates_dashboard?.startdates,
        selecteddates_dashboard?.enddates,
        flag,
        dateselected,
        'Diagnostics',
        userdetails.Organizationid,
        userdetails.Projectid === 'All' ? projectname : userdetails.Projectid,
        datacallback2
      );
    }
    
    // Early enrichment (may be partially filled) followed by subsequent enrich when data sources arrive
    setProcessedWidgets(enrichWidgets(widgets));
    // We'll turn off loading after either both sources loaded or timeout
  };

  // const widdisplay = (widgetdata) => {
  //   const series = widgetdata.runtimeSeries || buildWidgetSeries(widgetdata);
  //   const gridItem = displayLayout.find(l => l.i === String(widgetdata.id));
    
  //   // Debug logging
  //   if (!series || !series.length || !series.some(s => s.points && s.points.length)) {
  //     console.warn(`[Dashboard] Widget ${widgetdata.id} (${widgetdata.type}) has no data:`, { 
  //       widget: widgetdata, 
  //       series, 
  //       hasRuntimeSeries: !!widgetdata.runtimeSeries,
  //       tagprops: widgetdata?.props?.extended?.tagprops
  //     });
  //   }
    
  //   // Create unique key with data hash to force re-render when data changes
  //   const dataHash = series?.map(s => s.points?.length || 0).join('-');
  //   const widgetKey = `${widgetdata.id}-${dataHash}`;
    
  //   // Return only the grid item; the parent ResponsiveGridLayout wraps all new widgets together
  //   return (
  //     <div key={String(widgetdata.id)} data-grid={gridItem}>
  //       <WidgetCard 
  //         key={widgetKey}
  //         widget={widgetdata} 
  //         readOnly 
  //         viewOnly={true} 
  //         showPreviewGraph 
  //         data={series} 
  //       />
  //     </div>
  //   );
  // };


    const widdisplay = (widgetdata) => {
    const series = widgetdata.runtimeSeries || buildWidgetSeries(widgetdata);
    const gridItem = displayLayout.find(l => l.i === String(widgetdata.id));
    
    // Create unique key with data hash to force re-render when data changes
    const dataHash = series?.map(s => s.points?.length || 0).join('-');
    const widgetKey = `${widgetdata.id}-${dataHash}`;
    
    // Return only the grid item; the parent ResponsiveGridLayout wraps all new widgets together
    return (
      <div key={String(widgetdata.id)} 
      style={{
        height: '100%',
        width: '100%',
        background: "green"
      }}
      data-grid={gridItem}>
        <WidgetCard 
          key={widgetKey}
          widget={widgetdata} 
          readOnly 
          viewOnly={true} 
          showPreviewGraph 
          data={series} 
        />
      </div>
    );
  };

  //  const wisdsp = (widgetdata) => {
  //   const series = widgetdata.runtimeSeries || buildWidgetSeries(widgetdata);
  //   const gridItem = displayLayout.find(l => l.i === String(widgetdata.id));
    
  //   // Debug logging for old widgets
  //   if (!series || !series.length || !series.some(s => s.points && s.points.length)) {
  //     console.warn(`[Dashboard] Old Widget ${widgetdata.id} (${widgetdata.type}) has no data:`, { 
  //       widget: widgetdata, 
  //       series,
  //       hasRuntimeSeries: !!widgetdata.runtimeSeries,
  //       tagprops: widgetdata?.props?.extended?.tagprops
  //     });
  //   }
    
  //   // Create unique key with data hash to force re-render when data changes
  //   const dataHash = series?.map(s => s.points?.length || 0).join('-');
  //   const widgetKey = `${widgetdata.id}-${dataHash}`;
    
  //   return (
  //     <Grid item xs={widgetdata.props.basic.width}
  //     key={String(widgetdata.id)} 
  //     data-grid={gridItem}
  //      style={{ display:'flex' }}
  //     >
  //       <WidgetCard
  //         key={widgetKey}
  //         widget={widgetdata}
  //         readOnly
  //         viewOnly={true}
  //         showPreviewGraph
  //         data={series}
  //       />
  //     </Grid>
  //   );
  // };

    const wisdsp = (widgetdata) => {
    const gridItem = displayLayout.find(l => l.i === String(widgetdata.id));
    return (
      <Grid item xs={widgetdata.props.basic.width}
      key={String(widgetdata.id)} 
      data-grid={gridItem}
       style={{ display:'flex' }}
      >
        <Widgetcard
          widget={widgetdata}
          maxwidgetflag={false}
          maxicallback={maximizecallback}
        />
      </Grid>
    );
  };

   const widdisplay1 = (widgetdata, maxflag) => {
    return (
      <Grid item xs={widgetdata.props.basic.width}>
        <Widgetcard
          widget={widgetdata}
          maxwidgetflag={maxflag}
          maxicallback={maximizecallback}
        ></Widgetcard>
      </Grid>
    );
  };

  const loadingDisplay = () => (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',position: 'absolute', height: '100%', width: '100%' }}>
      <img src={LK_Loading} alt="loading..." style={{ height: "80px", width: "160px", alignSelf: "center" }} />
    </div>
  );

  // Build read-only layout whenever processedWidgets changes
  useEffect(() => {
    if (!Array.isArray(processedWidgets) || !processedWidgets.length) { setDisplayLayout([]); return; }
    const MAX_COLS = 4; // Align with configurator column count
    const allPersisted = processedWidgets.every(w => {
      const meta = w?.props?.extended?.gridmeta;
      return meta && [meta.x, meta.y, meta.w, meta.h].every(v => Number.isFinite(v));
    });
    let layout;
    if (allPersisted) {
      layout = processedWidgets.map(w => {
        const m = w.props.extended.gridmeta;
        return { i: String(w.id), x: m.x, y: m.y, w: Math.max(1, Math.min(MAX_COLS, m.w)), h: m.h || 2, minW:1, minH:2 };
      });
    } else {
      // Fallback packing ONLY for widgets missing coordinates
      let cursorX = 0, cursorY = 0;
      layout = processedWidgets.map(w => {
        const meta = w?.props?.extended?.gridmeta || {};
        let wVal = Number.isFinite(meta.w) ? meta.w : 1;
        let hVal = Number.isFinite(meta.h) ? meta.h : 2;
        if (wVal < 1) wVal = 1; if (wVal > MAX_COLS) wVal = MAX_COLS;
        if (Number.isFinite(meta.x) && Number.isFinite(meta.y)) {
          return { i: String(w.id), x: meta.x, y: meta.y, w: wVal, h: hVal, minW:1, minH:2 };
        }
        if (wVal > (MAX_COLS - cursorX)) { cursorX = 0; cursorY += 1; }
        const item = { i: String(w.id), x: cursorX, y: cursorY, w: wVal, h: hVal, minW:1, minH:2 };
        cursorX += wVal;
        if (cursorX >= MAX_COLS) { cursorX = 0; cursorY += 1; }
        return item;
      });
    }
    setDisplayLayout(layout);
  }, [processedWidgets]);

  // Re-enrich widgets whenever raw widget list or data sources change
  useEffect(() => {
    if (!dashboardjsonwidgets || !dashboardjsonwidgets.length) {
      setProcessedWidgets([]);
      return;
    }
    
    // Debounce enrichment to avoid race conditions when multiple data sources update
    const enrichTimer = setTimeout(() => {
      const enriched = enrichWidgets(dashboardjsonwidgets);
      setProcessedWidgets(enriched);
      
      // Log enrichment summary
      const withData = enriched.filter(w => 
        Array.isArray(w.runtimeSeries) && 
        w.runtimeSeries.some(s => s.points && s.points.length)
      );
    }, 100);
    
    return () => clearTimeout(enrichTimer);
  }, [dashboardjsonwidgets, tagcollectionvaluesnewjson, tagcollectionvalue, historicalvalues, livedataState, aggregatedDataPoints]);

  // Turn off loading state when data sufficiently loaded or after timeout
  useEffect(() => {
    if (!loadingWidgets) return;
    
    // Shorter timeout for better responsiveness
    const timeout = setTimeout(() => {
      setLoadingWidgets(false);
    }, 1500);
    
    // Check if we have sufficient data to display
    if (processedWidgets.length > 0) {
      const hasData = processedWidgets.some(w => 
        Array.isArray(w.runtimeSeries) && 
        w.runtimeSeries.some(s => s.points && s.points.length > 0)
      );
      
      if (hasData) {
        clearTimeout(timeout);
        setLoadingWidgets(false);
      }
    }
    
    return () => clearTimeout(timeout);
  }, [loadingWidgets, processedWidgets]);

  // Call dashboardDataPoints API once widgets available and on date range changes
  useEffect(() => {
    if (!dashboardjsonwidgets || !dashboardjsonwidgets.length) return;
    const payload = buildTagIdsForDataPoints(dashboardjsonwidgets);
    if (!payload.length) return;
    const sdate = selecteddates_dashboard?.startdates || sdate_edate_selected?.startdates;
    const edate = selecteddates_dashboard?.enddates || sdate_edate_selected?.enddates;
    if (!sdate || !edate) return;
    const datetype = dateselected || 'Custom';
    (async () => {
      const raw = await rawDashboardDataPoints(sdate, edate, datetype, payload);
      if (raw) {
        setAggregatedDataPoints(raw?.data || raw);
      } else {
        // fallback to existing wrapper
        const cb = (resp) => { try { setAggregatedDataPoints(resp?.data || resp); } catch(e){ console.error('dashboardDataPoints parse error', e);} };
        getDashboardDataPoints(sdate, edate, payload, datetype, cb);
      }
    })();
  }, [dashboardjsonwidgets, selecteddates_dashboard?.startdates, selecteddates_dashboard?.enddates, dateselected]);

  // Refetch historic data if date range changes (only for hist widgets)
  useEffect(() => {
    if (dashboardjsonwidgets && dashboardjsonwidgets.length) {
      const histWidgets = dashboardjsonwidgets.filter(w => w?.props?.extended?.datatype === 'hist');
      if (histWidgets.length) {
        gethistoricaldata(
          histWidgets,
          selecteddates_dashboard?.startdates,
          selecteddates_dashboard?.enddates,
          flag,
          dateselected,
          'Diagnostics',
          userdetails.Organizationid,
          userdetails.Projectid === 'All' ? projectname : userdetails.Projectid,
          datacallback2
        );
      }
    }
  }, [selecteddates_dashboard?.startdates, selecteddates_dashboard?.enddates, dateselected]);

  const handleCloseBackdrop = () => {
    setOpenbackdrop(false);
  };

  // Use displayLayout directly (removed temporary placeholder augmentation)
  const stableDisplayLayout = displayLayout;

  // Helper to render widgets or loading animation (simplifies JSX to avoid parser confusion)
  const renderWidgetsBlock = () => {
    if (!(Array.isArray(processedWidgets) && processedWidgets.length && !loadingWidgets)) {
      return loadingDisplay();
    }

 
    const newWidgets = processedWidgets.filter(w => w?.props?.isConfig === true);
    const oldWidgets = processedWidgets.filter(w => !w?.props?.isConfig);

    return (
      <div
        style={{
          height:"100%",
          width:"100%",
        }}
      >
        {newWidgets.length > 0 && (
          <ResponsiveGridLayout
            className="layout"
            rowHeight={160}
            breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
            cols={{ lg: 4, md: 3, sm: 2, xs: 1, xxs: 1 }}
            isDraggable={false}
            isResizable={false}
            layout={stableDisplayLayout}
            onLayoutChange={() => { /* read-only, ignore changes */ }}
          >
            {newWidgets.map(w => widdisplay(w))}
          </ResponsiveGridLayout>
        )}

        {oldWidgets.length > 0 && (
          <Grid container spacing={1} style={{ padding: "5px", overflow: "auto" }}>
            {oldWidgets.map(w => wisdsp(w))}
          </Grid>
        )}
      </div>
    );
  };
  return (
    <>
      {/*<ChatWidget />*/}
      <Box
        sx={{
          width: "71.1%",
          height: "100%",
          marginRight:
            "16px" 
        }}
      >
      {/* <div style={{ display: "flex", flexDirection: "row" }}>
        <Tabs
          value={tabvalue}
          onChange={handletabchange}
          TabIndicatorProps={{ hidden: true }}
          sx={{
            "& .MuiTabs-indicator": {
              display: "none",
              height: "0px",
              borderRadius: "0px",
              backgroundColor: "var(--action-button-light)",
              borderBottom: "1px solid var(--SecondaryBackground)",
            },
            "& .Mui-selected": {
              color: "var(--LK_BrandBlue_1) !important",
              fontWeight: "700 !important",
              backgroundColor: "var(--SecondaryBackground)",
              borderTop: "1px solid var(--HighlightedText_Stroke)",
              borderLeft: "1px solid var(--HighlightedText_Stroke)",
              borderRight: "1px solid var(--HighlightedText_Stroke)",
              borderBottom: "1px solid var(--SecondaryBackground)",
            },
            "& .MuiTab-root": {
              padding: "8px 8px 6px 8px !important",
              margin: "0px !important",
              minWidth: "63px",
            },
            minHeight: "30px",
            marginBottom: "-1px",
          }}
        >
          {maintabs.map((tab) => {
            return (
              <Tab
                sx={{
                  minHeight: "30px",
                  height: "30px",
                }}
                style={{
                  color: "var(--GreyVariation_2)",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "16.75px",
                  textTransform: "capitalize",
                }}
                value={tab}
                label={tab}
              >
                {tab}
              </Tab>
            );
          })}
        </Tabs>
      </div> */}
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Tabs
          value={maintabs.length > 0 ? tabvalue : "no-dashboard"}
          onChange={handletabchange}
          TabIndicatorProps={{ hidden: true }}
          sx={{
            "& .MuiTabs-indicator": {
              display: "none",
              height: "0px",
              borderRadius: "0px",
              backgroundColor: "var(--action-button-light)",
              borderBottom: "1px solid var(--SecondaryBackground)",
            },
            "& .Mui-selected": {
              color: "var(--LK_BrandBlue_1) !important",
              fontWeight: "700 !important",
              backgroundColor: "var(--SecondaryBackground)",
              borderTop: "1px solid var(--HighlightedText_Stroke)",
              borderLeft: "1px solid var(--HighlightedText_Stroke)",
              borderRight: "1px solid var(--HighlightedText_Stroke)",
              borderBottom: "1px solid var(--SecondaryBackground)",
            },
            "& .MuiTab-root": {
              padding: "8px 8px 6px 8px !important",
              margin: "0px !important",
              minWidth: "63px",
            },
            minHeight: "30px",
            marginBottom: "-1px",
          }}
        >
          {maintabs.length > 0 ? (
            maintabs.map((tab) => (
              <Tab key={tab} label={tab} value={tab} sx={{
                  minHeight: "30px",
                  height: "30px",
                }}
                style={{
                  color: "var(--GreyVariation_2)",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "16.75px",
                  textTransform: "capitalize",
                }}/>
            ))
          ) : (
            <Tab key="no-dashboard" label="No Dashboards" value="no-dashboard" sx={{
                  minHeight: "30px",
                  height: "30px",
                }}
                style={{
                  color: "var(--GreyVariation_2)",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "16.75px",
                  textTransform: "capitalize",
                }} />
          )}
        </Tabs>
      </div>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: "var(--SecondaryBackground)",
          padding: "8px",
          width: "100%",
          border: "1px solid var(--HighlightedText_Stroke)",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Tabs
            value={subtablist.length > 0 ? sectabvalue : "no-subtab"}
            onChange={handlesectabchange}
            sx={{
              "& .MuiTabs-indicator": {
                margin: "0px !important",
                height: "0px",
                borderRadius: "0px",
                backgroundColor: "var(--action-button-light)",
              },
              "& .Mui-selected": {
                color: "var(--LK_BrandBlue_1) !important",
                fontWeight: "700 !important",
                backgroundColor: "var(--PrimaryBackground)",
              },
              "& .MuiTab-root": {
                padding: "8px 8px 4px 8px!important",
                margin: "0px !important",
                minWidth: "63px",
              },
              minHeight: "28px",
            }}
          >
            {subtablist.length > 0 ? (
              subtablist.map((tab) => (
                <Tab key={tab} label={tab} value={tab} sx={{
                  minHeight: "30px",
                  height: "30px",
                }}
                style={{
                  color: "var(--GreyVariation_2)",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "16.75px",
                  textTransform: "capitalize",
                }}/>
              ))
            ) : (
              <Tab key="no-subtab" label="No Subtabs" value="no-subtab" sx={{
                  minHeight: "30px",
                  height: "30px",
                }}
                style={{
                  color: "var(--GreyVariation_2)",
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "16.75px",
                  textTransform: "capitalize",
                }} />
            )}
          </Tabs>
          <Box
            sx={{
              width: "100%",
              height: `calc(100vh - ${pagesize}px)`,
              backgroundColor: "var(--PrimaryBackground)",
              borderRadius: "0px 0px 0px 0px",
              overflow: "auto",
              padding: "2px",
              position: "relative",
            }}
          >
            <Backdrop
              sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
                position: "absolute",
                width: "100%",
                height: "100%",
              }}
              open={openbackdrop}
              onClick={handleCloseBackdrop}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            {maintabs.length === 0 || subtablist.length === 0 ? (
              <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="h6" color="textSecondary">
                  No dashboards or subtabs available for this node.
                </Typography>
              </Box>
            ) : nodashboard ? (
              <>
                {sectabvalue === 'Digital Twin' && <ThreeDScene />}
                {sectabvalue === 'Thermal Management' && <ThermalManagement />}
                {tabvalue === "SLD" && (
                  <div style={{ padding: "5px" }}>
                    {projectname === "ACE Baroda" ? (
                      <img
                        src={SLDimage_Baroda}
                        alt="SLD image"
                        style={{ width: "100%", height: "505px" }}
                      />
                    ) : (
                      <img
                        src={SLDimage_Delhi}
                        alt="SLD image"
                        style={{ width: "100%", height: "505px" }}
                      />
                    )}
                  </div>
                )}
                {(tabvalue !== 'SLD' && tabvalue !== 'Project SLD' && tabvalue !== 'Digital Twin' && tabvalue !== 'Thermal Management') &&
                  <Grid
                    container
                    spacing={1}
                    style={{ padding: "5px", overflow: "auto" }}
                  >
                    {renderWidgetsBlock()}
                  </Grid>
                }
                {tabvalue === "Project SLD" ? (
                  <>
                    {selectedtreepath[selectedtreepath.length - 1] === "Projects" && (
                      <div style={{ padding: "5px", width: "99%", height: "98%" }}>
                        <iframe
                          src={
                            "https://happy-rock-0bd606b1e.5.azurestaticapps.net/sld-integrate?_id=" +
                            sldid
                          }
                          title="SLD"
                          style={{
                            height: "100%",
                            width: "100%",
                            border: "0px",
                          }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  style={{
                    fontSize: "32px",
                    fontWeight: 500,
                    color: "var(--PrimaryText)",
                  }}
                ></Typography>
              </div>
            )}
          </Box>
        </Box>
      </Box>      
      
      {/* <Box
        style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: "var(--SecondaryBackground)",
          padding: "8px",
          width: "100%",
          border: "1px solid var(--HighlightedText_Stroke)",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Tabs
            value={sectabvalue}
            onChange={handlesectabchange}
            sx={{
              "& .MuiTabs-indicator": {
                margin: "0px !important",
                height: "0px",
                borderRadius: "0px",
                backgroundColor: "var(--action-button-light)",
              },
              "& .Mui-selected": {
                color: "var(--LK_BrandBlue_1) !important",
                fontWeight: "700 !important",
                backgroundColor: "var(--PrimaryBackground)",
              },
              "& .MuiTab-root": {
                padding: "8px 8px 4px 8px!important",
                margin: "0px !important",
                minWidth: "63px",
              },
              minHeight: "28px",
            }}
          >
            {subtablist.map((tab) => {
              return (
                <Tab
                  sx={{
                    minHeight: "28px",
                    height: "28px",
                  }}
                  style={{
                    color: "var(--GreyVariation_2)",
                    fontFamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "18.75px",
                    textTransform: "capitalize",
                  }}
                  value={tab}
                  label={tab}
                >
                  {tab}
                </Tab>
              );
            })}
          </Tabs>
          <Box
            sx={{
              width: "100%",
              height: `calc(100vh - ${pagesize}px)`,
              backgroundColor: "var(--PrimaryBackground)",
              borderRadius: "0px 0px 0px 0px",
              overflow: "auto",
              padding: "2px",
              position: "relative",
            }}
          >
            <Backdrop
              sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
                position: "absolute",
                width: "100%",
                height: "100%",
              }}
              open={openbackdrop}
              onClick={handleCloseBackdrop}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            {nodashboard ? (
              <>
                {
                        sectabvalue === 'Digital Twin' &&
                                <>
                                    {
                                       <ThreeDScene />
                                    }                                   
                                </>
                                }
                                {
                                sectabvalue === 'Thermal Management' &&
                                <>
                                    {
                                       <ThermalManagement />
                                    }

                                </>
                                }

                {tabvalue === "SLD" && (
                  <div style={{ padding: "5px" }}>
                    {projectname === "ACE Baroda" ? (
                      <img
                        src={SLDimage_Baroda}
                        alt="SLD image"
                        style={{ width: "100%", height: "505px" }}
                      />
                    ) : (
                      <img
                        src={SLDimage_Delhi}
                        alt="SLD image"
                        style={{ width: "100%", height: "505px" }}
                      />
                    )}
                  </div>
                )}
                {(tabvalue !== 'SLD' && tabvalue !== 'Project SLD' && tabvalue !== 'Digital Twin' && tabvalue !== 'Thermal Management') &&
                <Grid
                    container
                    spacing={1}
                    style={{ padding: "5px", overflow: "auto" }}
                  >
                    {renderWidgetsBlock()}
                  </Grid>

                }
                {tabvalue === "Project SLD" ? (
                  <>
                    {selectedtreepath[selectedtreepath.length - 1] ===
                      "Projects" && (
                      <div
                        style={{ padding: "5px", width: "99%", height: "98%" }}
                      >
                        <iframe
                          src={
                            "https://happy-rock-0bd606b1e.5.azurestaticapps.net/sld-integrate?_id=" +
                            sldid
                          }
                          title="SLD"
                          style={{
                            height: "100%",
                            width: "100%",
                            border: "0px",
                          }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  style={{
                    fontSize: "32px",
                    fontWeight: 500,
                    color: "var(--PrimaryText)",
                  }}
                ></Typography>
              </div>
            )}
          </Box>
        </Box>
      </Box>       */}
      </Box>

      <Dialog
        open={Boolean(maximizedWidget)}
        onClose={() => setMaximizedWidget(null)}
        fullWidth
        maxWidth="xl"
      >
        <DialogTitle sx={{ color: "var(--PrimaryText)" }}>
          {maximizedWidget?.widgetname || maximizedWidget?.widgetName || "Widget"}
        </DialogTitle>
        <DialogContent sx={{ minHeight: "70vh", backgroundColor: "var(--PrimaryBackground)" }}>
          {maximizedWidget && (
            <Widgetcard
              widget={{
                ...maximizedWidget,
                props: {
                  ...(maximizedWidget.props || {}),
                  basic: {
                    ...(maximizedWidget.props?.basic || {}),
                    width: "100%",
                    height: "65vh",
                  },
                },
              }}
              maxwidgetflag={true}
              maxicallback={maximizecallback}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
